import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import LazyHydration from 'components/LazyHydration';

import AdSenseSlot from './AdSenseSlot';

const InArticleAdSlot = ({ className, height = 280, slotId }) => (
  <LazyHydration placeholderSize={{ height }}>
    <AdSenseSlot
      className={twMerge('my-4 text-center', className)}
      format="fluid"
      height={height}
      layout="in-article"
      slotId={slotId}
    />
  </LazyHydration>
);

InArticleAdSlot.displayName = 'InArticleAdSlot';

InArticleAdSlot.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  slotId: PropTypes.string.isRequired,
};

export default InArticleAdSlot;
